import React, { useEffect, useState } from "react";
import UseInView from "../../components/Generic/UseInView";

const CohortPillar = ({ onClick }) => {
  const parts = [
    "/assets/images/Cohort/1.svg?ver=2",
    "/assets/images/Cohort/2.svg?ver=2",
    "/assets/images/Cohort/3.svg?ver=2",
    "/assets/images/Cohort/4.svg?ver=2",
    "/assets/images/Cohort/5.svg?ver=2",
    "/assets/images/Cohort/6.svg?ver=2",
    "/assets/images/Cohort/7.svg?ver=2",
    "/assets/images/Cohort/8.svg?ver=2",
    "/assets/images/Cohort/9.svg?ver=2",
    "/assets/images/Cohort/10.svg?ver=2",
    "/assets/images/Cohort/11.svg?ver=2",
    "/assets/images/Cohort/12.svg?ver=2",
    "/assets/images/Cohort/13.svg?ver=2",
    "/assets/images/Cohort/14.svg?ver=2",
    "/assets/images/Cohort/15.svg?ver=2",
    "/assets/images/Cohort/16.svg?ver=2",
    "/assets/images/Cohort/17.svg?ver=2",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const [containerRef, inView] = UseInView({ threshold: 0.3 }, false);

  // Preload images
  useEffect(() => {
    let loaded = 0;
    parts.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loaded++;
        if (loaded === parts.length) setImagesLoaded(true);
      };
    });
  }, []);

  // Animate when in view
  useEffect(() => {
    if (!imagesLoaded) return;

    let interval = null;

    if (inView) {
      interval = setInterval(() => {
        setPrevIndex(currentIndex);
        setCurrentIndex((prev) => {
          const next = prev + 1;
          if (next >= 17) return 0;
          return next;
        });
      }, 800);
    }

    return () => interval && clearInterval(interval);
  }, [inView, imagesLoaded, currentIndex]);

  return (
    <>
      <div
        ref={containerRef}
        className="cohort-filler-container"
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && onClick?.()}
        style={{ cursor: "pointer" }}
        aria-label="View cohort description"
      >
        {imagesLoaded ? (
          <>
            {prevIndex !== null && (
              <img
                key={prevIndex}
                src={parts[prevIndex]}
                className="cohort-image"
                alt=""
              />
            )}

            <img
              key={currentIndex}
              src={parts[currentIndex]}
              className="cohort-image fade-in"
              alt={`Cohort part ${currentIndex + 1}`}
            />
          </>
        ) : (
          <div className="cohort-placeholder">Loading...</div>
        )}
      </div>

      <style jsx>{`
        .cohort-filler-container {
          position: relative;
          width: 100%;
          max-width: 900px;
          aspect-ratio: 16 / 9;
          margin: 0 auto;
          overflow: hidden;
        }

        .cohort-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .fade-in {
          animation: fadeInSmooth 0.6s ease-in-out forwards;
        }

        @keyframes fadeInSmooth {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .cohort-placeholder {
          text-align: center;
          padding: 40px 0;
        }

        /* ADDED: mobile only fix */
        @media (max-width: 768px) {
          .cohort-filler-container {
            margin-top: -80px;
          }
        }
      `}</style>
    </>
  );
};

export default CohortPillar;

// import { motion, useAnimation } from "framer-motion";
// import { useEffect } from "react";
// import "../../styles/CohortPillars.css";
// import UseInView from "../../components/Generic/UseInView";

// const pillarVariants = {
//   hidden: { opacity: 0, scaleY: 0 },
//   visible: {
//     opacity: 1,
//     scaleY: 1,
//     transition: { duration: 0.8, ease: "easeOut" },
//   },
// };

// const slabVariants = {
//   hidden: { y: -200, opacity: 0 },
//   visible: {
//     y: 0,
//     opacity: 1,
//     transition: { duration: 0.9, ease: "easeOut" },
//   },
// };

// const cardsContainerVariants = {
//   hidden: {},
//   visible: {
//     transition: {
//       staggerChildren: 0.25,
//       delayChildren: 0.2,
//     },
//   },
// };

// const cardVariants = {
//   hidden: { y: -180, opacity: 0 },
//   visible: {
//     y: 0,
//     opacity: 1,
//     transition: { duration: 0.6, ease: "easeOut" },
//   },
// };

// const PILLARS = [
//   {
//     src: "/assets/images/Cohort/pillarstorytelling.svg",
//     alt: "Storytelling pillar",
//     className: "pillar left",
//   },
//   {
//     src: "/assets/images/Cohort/pillarevents.svg",
//     alt: "Events pillar",
//     className: "pillar center",
//   },
//   {
//     src: "/assets/images/Cohort/pillarmentorship.svg",
//     alt: "Mentorship pillar",
//     className: "pillar center overlay",
//   },
//   {
//     src: "/assets/images/Cohort/pillarprojects.svg",
//     alt: "Projects pillar",
//     className: "pillar right",
//   },
// ];

// const CARDS = [
//   {
//     src: "/assets/images/Cohort/crawlcard.svg",
//     alt: "Crawl",
//     className: "pillar-card crawl",
//   },
//   {
//     src: "/assets/images/Cohort/climbcard.svg",
//     alt: "Climb and Consolidate",
//     className: "pillar-card climb",
//   },
//   {
//     src: "/assets/images/Cohort/comebackcard.svg",
//     alt: "Comeback",
//     className: "pillar-card comeback",
//   },
//   {
//     src: "/assets/images/Cohort/commandcard.svg",
//     alt: "Command",
//     className: "pillar-card command",
//   },
//   {
//     src: "/assets/images/Cohort/cultivatecard.svg",
//     alt: "Cultivate and Craft",
//     className: "pillar-card cultivate",
//   },
// ];

// const delay = (ms) => new Promise((res) => setTimeout(res, ms));

// const CohortPillars = () => {
//   const pillarControls = useAnimation();
//   const slabControls = useAnimation();
//   const cardsControls = useAnimation();

//   const [ref, inView] = UseInView(
//     {
//       threshold: 0.4,
//       rootMargin: "0px 0px -100px 0px",
//     },
//     true,
//   );

//   useEffect(() => {
//     if (inView) {
//       // Reset first
//       pillarControls.set("hidden");
//       slabControls.set("hidden");
//       cardsControls.set("hidden");

//       // Play sequence once
//       const play = async () => {
//         await delay(200);
//         await pillarControls.start("visible");
//         await slabControls.start("visible");
//         await cardsControls.start("visible");
//       };

//       play();
//     } else {
//       // Stop + reset when out of view
//       pillarControls.stop();
//       slabControls.stop();
//       cardsControls.stop();

//       pillarControls.set("hidden");
//       slabControls.set("hidden");
//       cardsControls.set("hidden");
//     }
//   }, [inView, pillarControls, slabControls, cardsControls]);

//   return (
//     <div className="pillars-wrapper" ref={ref}>
//       {/* SLAB */}
//       <motion.img
//         src="/assets/images/Cohort/slab.svg"
//         alt="Slab"
//         className="pillar-overlay"
//         variants={slabVariants}
//         initial="hidden"
//         animate={slabControls}
//       />

//       {/* CARDS */}
//       <motion.div
//         className="pillar-cards-container"
//         variants={cardsContainerVariants}
//         initial="hidden"
//         animate={cardsControls}
//       >
//         {CARDS.map((card, index) => (
//           <motion.img
//             key={index}
//             src={card.src}
//             alt={card.alt}
//             className={card.className}
//             variants={cardVariants}
//           />
//         ))}
//       </motion.div>

//       {/* PILLARS */}
//       <motion.div
//         className="pillars-container"
//         initial="hidden"
//         animate={pillarControls}
//         transition={{ staggerChildren: 0.4 }}
//       >
//         {PILLARS.map((pillar, index) => (
//           <motion.img
//             key={index}
//             src={pillar.src}
//             alt={pillar.alt}
//             className={pillar.className}
//             variants={pillarVariants}
//             style={{ transformOrigin: "bottom" }}
//           />
//         ))}
//       </motion.div>
//     </div>
//   );
// };

// export default CohortPillars;
